// catalogSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { TypeOfAnimal } from '../services/catalogApi'

// Define the initial state
interface CatalogState {
    currentCatalogCategory: TypeOfAnimal[]
    catalogBreadCrumbs: string[]
    subCategory: TypeOfAnimal | null
}

const initialState: CatalogState = {
    currentCatalogCategory: [],
    catalogBreadCrumbs: ['Каталог'],
    subCategory: null
}

// Create a slice
const catalogSlice = createSlice({
    name: 'catalogCategory',
    initialState,
    reducers: {
        setCurrentCatalogCategory: (state, action: PayloadAction<TypeOfAnimal[]>) => {
            state.currentCatalogCategory = action.payload
        },
        setCatalogBreadCrumbs: (state, action: PayloadAction<string[]>) => {
            state.catalogBreadCrumbs = action.payload
        },
        setSubCategory: (state, { payload }: PayloadAction<TypeOfAnimal | null>) => {
            state.subCategory = payload
        }
    }
})

// Export the actions and reducer
export const { setCatalogBreadCrumbs, setCurrentCatalogCategory, setSubCategory } = catalogSlice.actions
export default catalogSlice.reducer
